export const EDGE = 'EDGE';
export const NODE = 'NODE';
